<template>
  <div>
      <Row>
        <Col span="3" >
          <Content :style="{'height':maxHeight}">
            <el-table ref="table" :data="packagesList" highlight-current-row highlight-selection-row :show-header="false"
                      :max-height="maxHeight" :row-class-name="tableRowClassName" @row-click="handleRowClick">
              <el-table-column fixed prop="name" show-overflow-tooltip  max-width="50"/>
            </el-table>
          </Content>

        </Col>
        <Col span="21">
          <RequiredManageField ref="screeningFormList" v-if="queryProjectsData && queryProjectsData.length > 0" :queryProjectsData.sync="queryProjectsData"
                             :style="{'max-height':maxHeight,'overflow-y':'auto','box-sizing':'border-box'}"/>
        </Col>
      </Row>
  </div>
</template>
<script>
import RequiredManageField from "./RequiredManageField.vue"
import {_packagesName} from "@/services/screeningConfig/phlysicalPackage";
import {_getPhysicalFormByPackage} from "@/services/screeningConfig/requiredItemConfig";
export default {
  name: "RequiredManage",
  components: { RequiredManageField},
  props: {
  },
  data() {
    return {
      maxHeight: window.innerHeight - 200,
      currentRowIndex: 0,
      packagesList:[],
      queryProjectsData:[],
    };
  },
  mounted() {
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
    if (this.$userSession.checkInstitutionId()) {
      this.applyPhysicalDateList();
    }
  },
  watch:{

  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.maxHeight = `${height - 135}px`;
    },
    tableRowClassName(row) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "current-row";
      }
    },
    handleRowClick(e, index, event){
      this.currentRowIndex = index;
      this.applyPhysicalFormByPackage(e.id);
    },
    applyPhysicalDateList(){
      this.queryProjectsData = [];
      this.packagesList = [];
      _packagesName().then(res=>{
        if (res.errcode === 1 && res.data){
          this.packagesList = Object.assign([], res.data);
          this.applyPhysicalFormByPackage(this.packagesList[0].id);
        }
      }).catch(e=>{
        this.packagesList = [];
      })
    },
    applyPhysicalFormByPackage(packagesId){
      this.queryProjectsData = [];
      _getPhysicalFormByPackage({packagesId: packagesId}).then(res=>{
        if (res.errcode === 1){
          this.queryProjectsData= Object.assign([], res.data);
        }
      }).catch(e=>{
        this.queryProjectsData = [];
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
/*.el-table{
  border: 1px solid #ccc;
}*/
/deep/ .el-table__body tr.current-row>td.el-table__cell, .el-table__body tr.selection-row>td.el-table__cell {background-color: #beffc5;}
/deep/ .el-table .current-row td{background: #beffc5;color: #101010;}
/deep/ .ivu-table .current-row td{background: #beffc5;color: #101010;}
/* 移除外层包裹的伪元素边框 */
/deep/ .el-table::before {height: 0 !important;  /* 底部外边框 */}
/deep/ .el-table__fixed::before,
/deep/ .el-table__fixed-right::before {width: 0 !important;  /* 移除固定列左侧分隔线 */}
/* 清除带有 border 属性的表格边框 */
/deep/ .el-table--border,
/deep/ .el-table--group {border: none !important;  /* 完全移除外框线 */}
/deep/ .el-table td.el-table__cell,
/deep/ .el-table th.el-table__cell {border: none !important;  /* 移除单元格所有边框 */}

</style>
